<template>
	<section class="vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1">
		<div class="vx-col w-full md:w-full lg:w-5/6">
			<vx-card>
				<header class="vx-row justify-between">
					<div class="vx-col w-full md:w-1/2 mb-8 flex items-center">
						<router-link :to="`/campaign/donation-amount/${this.$route.params.slug_and_id}`">
							<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
						</router-link>
						<strong class="block text-primary"><small>Menunggu Pembayaran</small></strong>
					</div>
					<div class="vx-col hidden md:flex md:w-1/2 flex justify-end">
						
					</div>
				</header>

				<div class="flex justify-center mb-12">
					<img src="/assets/images/topup/confirm.svg" alt="" class="md:w-1/4 w-1/6" />
				</div>
				<section class="vx-row justify-center mb-12" v-if="history.metode_pembayaran">
					<div class="vx-col lg:w-5/6 xl:w-2/3">
						<table class="w-full">
							<tr>
								<td class="text-left py-2"><strong class="text-dark">Campaign</strong></td>
								<td class="text-right py-2"><strong class="text-grey">{{ truncateString(campaign.name, 150) }}</strong></td>
							</tr>
							<tr>
								<td class="text-left py-2">
									<strong class="text-dark">Total Pembayaran</strong>
								</td>
								<td class="text-right py-2">
									<strong class="text-grey">Rp {{ formatRupiah(history.jumlah_bayar) }}</strong>
								</td>
							</tr>
						</table>
						<vs-divider class="my-4"></vs-divider>
						<!-- VA -->
						<div v-if="history.metode_pembayaran.category === 'bank_transfer'">
							<table class="w-full">
								<tr>
									<td class="text-left">
										<img v-if="history.file_url !== null" :src="history.file_url" alt="" class="w-16 md:w-24" />
									</td>
									<td class="text-center">
										<h6 class="mb-2">{{ history.metode_pembayaran.name }}</h6>
										<strong class="block">{{ history.no_pembayaran }}</strong>
										<small class="text-danger">Pembayaran Berakhir pada {{history.expired}}</small>
									</td>
									<td></td>
								</tr>
							</table>
						</div>
						<!-- / -->
						<!-- USING GOPAY -->
						<div  v-if="history.metode_pembayaran.code === 'gopay'">
							<header class="flex justify-center">
								<img v-if="history.qr_checkout_url !== null" :src="history.qr_checkout_url" alt="" class="w-full md:w-1/2 lg:w-1/4" />	
							</header>
							<vs-collapse>
							<vs-collapse-item>
								<div slot="header">
									<small>
										<strong>Petunjuk Bayar</strong>
									</small>
								</div>
								<div>
									<strong>
									Silahkan bayar <a :href="history.web_checkout_url" style="color: blue" target="_blank">disini</a>
									</strong>
								</div>
							</vs-collapse-item>

						</vs-collapse>
						</div>

					</div>
				</section>
				<section class="mb-6" v-else>
					<h3 class="text-center mb-2">Mohon maaf ada kesalahan saat pembayaran kamu</h3>
					<p>Coba ulangi transaksinya</p>
				</section>
				<vs-button class="w-full rounded-lg" @click.prevent="toHome">
					<strong class="text-white">Ok</strong>
				</vs-button>
			</vx-card>
		</div>
	</section>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
	  campaign: {name: ''},
    history: {},
    payment: {},
    mBankingGuide: [
      {
        no: 1,
        text: 'Pilih m-Transfer > BCA VA'
      },
      {
        no: 2,
        text: 'Masukan nomer VA dan pilih send, periksa informasi dilayar, pastikan merchant adalah ZX, username dan nama user anda'
      },
      {
        no: 3,
        text: 'Masukan PIN anda, lalu konfirmasi'
      },
      {
        no: 4,
        text: 'Jika transaksi gagal, maka ulangi transaksi menggunakan ATM'
      }
    ]
  }),
  methods: {
    copy () {

    },
    toHome() {
    	// Delete state payment and product
    	this.$store.dispatch('campaign/deleteTransactionHistory')
      this.$store.dispatch('campaign/deleteTransactionProduct')
      this.$store.dispatch('campaign/deleteTransactionPayment')
      this.$store.dispatch('campaign/deleteTransactionAmount')
      this.$store.dispatch('campaign/deleteTransactionTypes')

    	this.$router.push('/home')
    }
  },
  computed: {
    ...mapState('campaign', ['transactionHistory'])
  },
  created () {
  	this.checkVerifyAccount();
  	if(this.history == null) {
  		this.$router.push('/home');
  	}
	// get id from slug
	const arrSlug = this.$route.params.slug_and_id.split('-'),
			id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString();

	this.$store.dispatch('campaign/getDetail', id)
	.then(campaign => {
		Object.assign(this.campaign, campaign);
	})
	.catch(e => console.error(e));

	Object.assign(this.history, this.transactionHistory);

	if(this.history && this.history.metode_pembayaran) {
		if(['ID_LINKAJA', 'ID_DANA'].includes(this.history.metode_pembayaran.code)) {
			if(this.history.web_checkout_url) {
				window.location.href = this.history.web_checkout_url;
			}
		}

		this.history.file_url = null;
		if(this.history.metode_pembayaran.file !== null) {
			this.history.file_url = process.env.VUE_APP_STORAGE + '/' + this.history.metode_pembayaran.file;
		}
	}
  }
}
</script>